import { BenefitCard } from './BenefitCard';
import { SectionHeading } from './SectionHeading';
import { competencies } from '../content/site';
import styles from './BenefitsSection.module.css';
export function BenefitsSection() {
  return (
    <section className={styles.section}>
      <SectionHeading eyebrow="Наши компетенции" title="Когда важна каждая деталь" />
      <div className="grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3">
        {competencies.map((x, i) => (
          <BenefitCard key={x.i} index={i} title={x.t} description={x.d} />
        ))}
      </div>
    </section>
  );
}
